import type { ManeuverType } from '../shared/types';
import type { LaneArrow } from '../nav/lanes';

/**
 * 案内の矢印（SVG）。線で描いて currentColor で色を付ける。
 * 右向きは左向きを左右反転して使う
 */

const svg = (body: string, mirror = false) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${
    mirror ? `<g transform="translate(24 0) scale(-1 1)">${body}</g>` : body
  }</svg>`;

const STRAIGHT = '<path d="M12 21V4"/><path d="M6 10l6-6 6 6"/>';
const SLIGHT_LEFT = '<path d="M15 21v-7L8 7"/><path d="M8 12.5V7h5.5"/>';
const LEFT = '<path d="M15 21V11H5"/><path d="M9 7l-4 4 4 4"/>';
const SHARP_LEFT = '<path d="M16 21V5L7 14"/><path d="M7 8.5V14h5.5"/>';
const UTURN = '<path d="M16 21V10a4 4 0 0 0-8 0v5"/><path d="M4.5 12L8 15.5 11.5 12"/>';
const ARRIVE = '<path d="M6 21V4"/><path d="M6 4h11l-3 4 3 4H6"/>';
const ROUNDABOUT = '<circle cx="12" cy="9" r="4.5"/><path d="M12 21v-7.5"/><path d="M16.5 9H21"/><path d="M18.5 6.5L21 9l-2.5 2.5"/>';

export function maneuverIcon(m: ManeuverType | 'arrived'): string {
  switch (m) {
    case 'slight-left':
      return svg(SLIGHT_LEFT);
    case 'left':
      return svg(LEFT);
    case 'sharp-left':
      return svg(SHARP_LEFT);
    case 'slight-right':
      return svg(SLIGHT_LEFT, true);
    case 'right':
      return svg(LEFT, true);
    case 'sharp-right':
      return svg(SHARP_LEFT, true);
    case 'uturn':
      return svg(UTURN);
    case 'roundabout':
      return svg(ROUNDABOUT);
    case 'arrive':
    case 'arrived':
      return svg(ARRIVE);
    default:
      return svg(STRAIGHT); // depart / straight / merge / ramp / unknown
  }
}

const LANE_BODY: Record<LaneArrow, [string, boolean]> = {
  left: [LEFT, false],
  slight_left: [SLIGHT_LEFT, false],
  through: [STRAIGHT, false],
  slight_right: [SLIGHT_LEFT, true],
  right: [LEFT, true],
};

/** 車線の矢印。1つの車線に複数の向きがあれば重ねて描く（「↖↑」） */
export function laneIcon(arrows: LaneArrow[]): string {
  const body = arrows
    .map((a) => {
      const [b, mirror] = LANE_BODY[a];
      return mirror ? `<g transform="translate(24 0) scale(-1 1)">${b}</g>` : b;
    })
    .join('');
  return svg(body);
}

/** 方位磁針（上が北。赤い側が北） */
export const COMPASS = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l4 9.5h-8z" fill="#e5484d"/><path d="M12 21.5l-4-9.5h8z" fill="#cfd6e4"/><text x="12" y="8.6" text-anchor="middle" font-size="4.2" font-weight="800" fill="#fff" font-family="sans-serif">N</text></svg>`;
